/**
 * portalEvent — telling a portalled descendant's events from the element's own.
 *
 * React bubbles a synthetic event up the REACT tree, so a menu or dialog
 * portalled to the body still delivers its presses and keystrokes to every
 * handler above it in the component tree. A drag surface hosting a context
 * menu hears the press on a menu item as a press on itself, captures the
 * pointer, and takes the pointerup and the click away from the item — the menu
 * then does nothing. The DOM is what tells the two apart: a portalled target is
 * not inside the element handling the event.
 */

/** The two fields the check reads, off a synthetic or a native event alike. */
interface PortalCheckable {
    currentTarget: { contains(node: unknown): boolean } | null;
    target: unknown;
}

/** True when `e` reached the handling element through a portal. */
export function isFromPortal(e: PortalCheckable): boolean {
    const host = e.currentTarget;
    return !!host && !!e.target && !host.contains(e.target);
}
